import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CreatePickupZoneDto, PickupZone, UpdatePickupZoneDto } from "../types/api/api-types";
import { axiosApi } from "./axios";

const createPickupZone = async (data: CreatePickupZoneDto) => {
  return axiosApi.post(`/pickup-zones`, data);
};

export const useCreatePickupZone = () => {
  const { t } = useTranslation(["boLogistics", "common"]);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPickupZone,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pickupZones"] });
      toast.success(t("pickupZoneApi.createSuccess"));
    },
    onError: () => {
      toast.error(t("common:errors.generic"));
    },
  });
};

const updatePickupZone = async ({ data, id }: { data: UpdatePickupZoneDto; id: string }) => {
  return axiosApi.patch(`/pickup-zones/${id}`, data);
};

export const useUpdatePickupZone = () => {
  const { t } = useTranslation("boLogistics");
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePickupZone,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pickupZones"] });
      toast.success(t("pickupZoneApi.updateSuccess"));
    },
    onError: () => {
      toast.error(t("pickupZoneApi.updateError"));
    },
  });
};

const getPickupZones = async () => {
  return axiosApi.get<PickupZone[]>("/pickup-zones").then((res) => res.data);
};

export const useGetPickupZones = () => {
  return useQuery({
    queryKey: ["pickupZones"],
    queryFn: () => getPickupZones(),
    enabled: true,
  });
};
